/**
 * Catalog colour → Badge variant, and the variant union itself (#2169 PR-2).
 *
 * At the FRAMEWORK-FREE root rather than next to the registry that used to own
 * it, because its consumers are on both sides of the render axis: the enum cell
 * and the detail-header status slot render a `<Badge>`, while dashboard widgets
 * and resource definitions only need to NAME a variant. A module that names a
 * variant should not have to evaluate React to do it.
 */
export type BadgeVariant = 'default' | 'secondary' | 'destructive' | 'outline' | 'success';

const ENUM_BADGE_VARIANT_MAP: Record<string, BadgeVariant> = {
  success: 'success',
  warning: 'secondary',
  destructive: 'destructive',
  primary: 'default',
  secondary: 'secondary',
  outline: 'outline',
};

/**
 * Shared catalog-color → Badge-variant mapping. Exported so ad-hoc Badge
 * callsites (dashboard widgets, detail trees) stay consistent with the
 * schema-driven enum renderer instead of hand-rolling per-status if-chains
 * (#1254).
 */
export const enumBadgeVariant = (color?: string): BadgeVariant =>
  (color && ENUM_BADGE_VARIANT_MAP[color]) || 'outline';
